module.exports = __webpack_public_path__ + "static/media/Portrait-Default.83717788.jpg";